import {useDispatch, useSelector} from "react-redux";
import {change_search_word, clearSearchResult, searchItemClick, searchKeyPress} from "../redux/actions";
import {useEffect, useRef} from "react";
import searchIcon from '../images/searchByUser.svg'
import loaderIcon from '../images/loader.svg'

export const SearchByUser = () => {
    const dispatch = useDispatch()
    const searchWord = useSelector(state => state.table.searchWord)
    const searchItems = useSelector(state => state.table.searchItems)
    const searchLoader = useSelector(state => state.table.searchLoader)
    const id = useSelector(state => state.user.id)
    const lang = useSelector(state => state.app.currentLang)
    const list = useSelector(state => state.table.list)
    const rootEl = useRef(null);
    let timer = null;


    useEffect(() => {
        if (list.length > 0) {
            const onClick = e => ((rootEl.current && rootEl.current !== null && e.target !== null && rootEl.current.contains(e.target)) || dispatch(clearSearchResult()));
            document.addEventListener('click', onClick);
            return () => document.removeEventListener('click', onClick);
        }
    }, [dispatch, list]);

    const handleKeyPress = (event) => {
        const value = event.target.value

        clearTimeout(timer);
        timer = setTimeout(function () {
            dispatch(searchKeyPress(value, id))
        }, 100);

        dispatch(change_search_word(value));


    }
    const handleSearchPress = (e) => {
        e.preventDefault()
        dispatch(searchItemClick(searchWord, id, lang.games13))
    }

    if (list.length === 0) {
        return null;
    }
    return (
        <div className="searchByUser" ref={rootEl}>
            <form className="searchByUser__wrap" onSubmit={(e) => handleSearchPress(e)}>
                <input  type="text" name="searchByUser"  autoComplete="off" placeholder={lang.table2}
                       onChange={(e) => handleKeyPress(e)}
                       value={searchWord}
                />
                <div className="searchByUser__icon_block">
                    <button className="searchByUser__icon" type="submit" value="" >
                        {
                            searchLoader
                                ? <img src={loaderIcon} alt="loader"/>
                                : <img src={searchIcon} alt="search"/>

                        }
                    </button>
                </div>

                {
                    searchItems.length > 0 && (
                        <div className="searchByUser__results">
                            {
                                searchItems.map((item) => {
                                    return (<div onClick={() => dispatch(searchItemClick(item, id, lang.games13))}
                                                 key={item}>{item}</div>);
                                })
                            }
                        </div>
                    )
                }

            </form>
        </div>
    )
}